storefrontApp.service('homepageService', ['$http','commonService', function($http,commonService) {
    return {
        getCarousalAds: function() {
            return $http.get('storefrontapi/carousel-ads');
        },

        getCarousalSubAds: function () {
            return $http.get('storefrontapi/carousel-SubAds');
        },

        getHomePageContent: function () {
            return $http.get('storefrontapi/homepage-content');
        },

        getBottomAds: function () {
            return $http.get('storefrontapi/activebottomads');
        },

        getContent: function(value){
            if(angular.isUndefined(value) || value === null){
                return null;
            }
            storedValues = value.split("expiry:");
            if(storedValues != null && storedValues.length > 1 && commonService.checkAdExpiry(storedValues[1]))
            {
                return storedValues[0];
            }
            return null;
        },

        getCommunityArticles: function() {
            return $http.get('storefrontapi/getatgcommunityarticles');
        },
        getDigitalEvents: function (count) {
            return $http.get('storefrontapi/digitalevents?count='+count);
        },

    }
}]);
